module.exports = {
  language: 'Ukrainian',
  nationalityKay: 'uk-ua',
  personal: {
    purgePopupContent:
      'На жаль, дані вашої заявки видалено через політику безпеки. Ви можете зв’язатися з нами, якщо захочете незабаром подати заявку'
  },
  login_maximum: {
    errorContent: 'You have reached maximum login times, please retry the next day.'
  },
  noneSelectedText: 'Будь ласка, оберіть',
  multiselect: {
    deselect: 'Натисніть Enter, щоб видалити',
    select: 'Натисніть Enter, щоб вибрати',
    selected: 'Обрано'
  },
  enter: 'Введіть',
  upload_failed: 'Помилка завантаження, повторіть спробу',
  due_time: 'Час завершення',
  requirement: 'Вимога',
  something_went_wrong_please_retry: 'Щось пішло не так, спробуйте ще раз.',
  valid_rediret_home_page_popup_content:
    'Виникла виняток при вході. Ви намагаєтесь зайти на домашню сторінку [ {country} - {center} ], щоб увійти в систему? Якщо так, будь ласка, натисніть "Підтвердити"; якщо ні, натисніть "Скасувати", щоб спробувати ще раз.',
  invalid_rediret_home_page_popup_content: 'Виникла помилка входу, будь ласка, оберіть країну та місцевість, щоб продовжити.',
  'Temporarily not available': 'Тимчасово недоступний',
  'Coming soon': 'Незабаром'
};
